module.exports = __webpack_public_path__ + "static/img/20012 (3).4817280.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20000/20012 (3).webp
// module id = iJLs
// module chunks = 14